const ACTIONS = {
    OPEN_ALERT_DIALOG: 'OPEN_ALERT_DIALOG',
    CLOSE_ALERT_DIALOG: 'CLOSE_ALERT_DIALOG'
};

const INITIAL_STATE = {
    open: false,
    title: '',
    description: ''
};

export function AlertDialogReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.OPEN_ALERT_DIALOG:
            return {
                ...state,
                open: true,
                title: action.title,
                description: action.description
            };
        case ACTIONS.CLOSE_ALERT_DIALOG:
            return { ...state, open: false };
        default:
            return state;
    }
}
